import React from "react";
import styles from "./consentShared.module.scss";

export const ConsentFilterBar = ({
  children,
  resultText,
  onClear,
  className = "",
}: {
  children: React.ReactNode;
  resultText?: string;
  onClear?: () => void;
  className?: string;
}) => (
  <section className={`${styles.filterBar} ${className}`} aria-label="Consent filters">
    <div className={styles.filterFields}>{children}</div>
    {(resultText || onClear) && (
      <div className={styles.filterFooter}>
        {resultText && <span aria-live="polite">{resultText}</span>}
        {onClear && <button type="button" className={styles.clearFilters} onClick={onClear}>Clear filters</button>}
      </div>
    )}
  </section>
);
